/* Non-critical fonts */
document.addEventListener("DOMContentLoaded",function(){var style=document.createElement("style");style.textContent=`@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/miyuki/Figtree-Light.ttf");font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/miyuki/Figtree-Regular.ttf");font-weight:400;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/miyuki/Figtree-Medium.ttf");font-weight:500;font-style:normal;font-display:swap;}@font-face{font-family:"Figtree";src:url("https://d2izr24fok1gc0.cloudfront.net/miyuki/Figtree-Bold.ttf");font-weight:700;font-style:normal;font-display:swap;}@font-face{font-family:"BigMoore";src:url("https://d2izr24fok1gc0.cloudfront.net/miyuki/BigMoore-Regular.otf");font-weight:400;font-style:normal;font-display:swap;}`;document.head.appendChild(style);});
/* Start Section myk_jquery_tqjmRD */
document.addEventListener('DOMContentLoaded',()=>{const bundleSetBtn=document.querySelector('[data-bundle]');const allSingleAddToCartBtns=document.querySelectorAll('[data-add-single]');const all_other_variants=Array.from(allSingleAddToCartBtns).map(btn=>btn.dataset.id);let giftData=["41439990513751"]
async function fetchCartContents(){try{const response=await fetch("/cart.js");if(!response.ok)throw new Error("Failed to fetch cart data");const cartData=await response.json();return cartData.items.map(item=>({id:String(item.id),quantity:item.quantity}));}catch(error){console.error("Error fetching cart data:",error);return[];}}
function calculateBundleCountPostItemAdd(cartItems,itemsBeingAdded,all_other_variants){let updatedCartItems=[...cartItems];itemsBeingAdded.forEach(itemToAdd=>{let existingItem=updatedCartItems.find(cartItem=>cartItem.id===String(itemToAdd.id));if(existingItem){existingItem.quantity+=itemToAdd.quantity;}else{updatedCartItems.push({id:String(itemToAdd.id),quantity:itemToAdd.quantity});}});let bundleCount=Infinity;all_other_variants.forEach(variantId=>{let item=updatedCartItems.find(cartItem=>cartItem.id===String(variantId));if(!item){bundleCount=0;}else{bundleCount=Math.min(bundleCount,item.quantity);}});return bundleCount;}
function calculateGiftCount(cartItems,giftData){let giftCount=0;giftData.forEach(giftId=>{let giftItem=cartItems.find(item=>item.id===String(giftId));if(giftItem){giftCount+=giftItem.quantity;}});return giftCount;}
function getItemsToCompleteBundleAfterRemovingFullSets(cartItems,bundleVariants){if(!cartItems||cartItems.length===0){return bundleVariants.map(id=>({id:id,quantity:1}));}
const variantQuantities={};bundleVariants.forEach(id=>(variantQuantities[id]=0));cartItems.forEach(item=>{if(bundleVariants.includes(item.id)){variantQuantities[item.id]=item.quantity;}});console.log("Initial bundle variant quantities:",variantQuantities);const minQuantity=Math.min(...Object.values(variantQuantities));if(minQuantity>0){bundleVariants.forEach(id=>{variantQuantities[id]-=minQuantity;});}
console.log("After removing full bundles:",variantQuantities);let itemsToAdd=[];bundleVariants.forEach(id=>{if(variantQuantities[id]<=0){itemsToAdd.push({id:id,quantity:1});}});return itemsToAdd;}
async function handleAddToCart(event){
  event.preventDefault();
  const btn=event.currentTarget;btn.classList.add("spin");
  const variantId=btn.dataset.id;if(!variantId){console.error("Variant ID missing!");btn.classList.remove("spin");return;}
try{const cartItems=await fetchCartContents();let items=[{id:variantId,quantity:1}];const newBundleCount=calculateBundleCountPostItemAdd(cartItems,items,all_other_variants);
    const currentGiftCount=calculateGiftCount(cartItems,giftData);console.log("Bundles in cart after adding:",newBundleCount);
    console.log("Current gift count:",currentGiftCount);if(newBundleCount>currentGiftCount){const giftsToAdd=newBundleCount-currentGiftCount;console.log(`Adding ${giftsToAdd}gift(s)to cart...`);for(let i=0;i<giftsToAdd;i++){items.push({id:giftData[0],quantity:1});}}
const response=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:items}),});if(!response.ok){throw new Error("Failed to add to cart");}
const result=await response.json();console.log("Items added to cart:",result);window.location.href="/cart";}catch(error){console.error("Error adding to cart:",error);}finally{btn.classList.remove("spin");}}
async function handleCompleteBundleClick(event){event.preventDefault();const btn=event.currentTarget;btn.classList.add("spin");try{const cartItems=await fetchCartContents();const itemsToAdd=getItemsToCompleteBundleAfterRemovingFullSets(cartItems,all_other_variants);console.log("itemsToAdd:",itemsToAdd);if(itemsToAdd.length===0){console.log("No missing items. Bundle already complete.");btn.classList.remove("spin");window.location.href="/cart";return;}
const newBundleCount=calculateBundleCountPostItemAdd(cartItems,itemsToAdd,all_other_variants);console.log("Updated bundle count after adding:",newBundleCount);const currentGiftCount=calculateGiftCount(cartItems,giftData);console.log("Current gift count in cart:",currentGiftCount);let 
  giftsToAdd=[];
if(newBundleCount>currentGiftCount){
  const giftQuantityToAdd=newBundleCount-currentGiftCount;
  // giftsToAdd.push({id:giftData[0],quantity:giftQuantityToAdd});console.log(`Adding ${giftQuantityToAdd}gift(s)to cart.`);
}
const finalItemsToAdd=[...itemsToAdd,...giftsToAdd];const response=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:finalItemsToAdd}),});if(!response.ok){throw new Error("Failed to add items to cart");}
const result=await response.json();console.log("Items added to cart:",result);window.location.href="/cart";}catch(error){console.error("Error adding bundle items:",error);}finally{btn.classList.remove("spin");}}

  // allSingleAddToCartBtns.forEach(btn=>{btn.addEventListener("click",handleAddToCart);});
                                                  // if(bundleSetBtn){bundleSetBtn.addEventListener("click",handleCompleteBundleClick);}



function createCartFormData(items) {
    const formData = new FormData();

    // Loop through items and append them in Shopify's format
    items.forEach((item, index) => {
        formData.append(`items[${index}][id]`, item.id);
        formData.append(`items[${index}][quantity]`, item.quantity || 1);
    });

    // Add additional required fields
    formData.append("sections", "cart-drawer,cart-icon-bubble");
    formData.append("sections_url", "/pages/miyuki-launch-page");

    return formData;
}

                                                  
async function getItemsToAddOnSingleAddToCart(variantId, all_other_variants, giftData) {
  const cartItems = await fetchCartContents();

  let items = [{ id: variantId, quantity: 1 }]; // Base item to add
  
    // Calculate bundles in cart AFTER adding this variant
    const newBundleCount = calculateBundleCountPostItemAdd(cartItems, items, all_other_variants);
    const currentGiftCount = calculateGiftCount(cartItems, giftData);

    console.log("Bundles in cart after adding:", newBundleCount);
    console.log("Current gift count:", currentGiftCount);


    // If bundle count exceeds gift count, add missing gift(s)
    if (newBundleCount > currentGiftCount) {
        const giftsToAdd = newBundleCount - currentGiftCount;
        console.log(`Adding ${giftsToAdd} gift(s) to cart...`);
        for (let i = 0; i < giftsToAdd; i++) {
            items.push({ id: giftData[0], quantity: 1 }); // Add gift item to cart
        }
    }
  return items;
}

async function getItemsToAddOnBundleAddToCart(variantId, all_other_variants, giftData) {
        // Step 1: Fetch current cart contents
        const cartItems = await fetchCartContents();

        // Step 2: Determine missing items to complete a bundle
        const itemsToAdd = getItemsToCompleteBundleAfterRemovingFullSets(cartItems, all_other_variants);

      console.log("itemsToAdd:", itemsToAdd);
        if (itemsToAdd.length === 0) {
            console.log("No missing items. Bundle already complete.");
            btn.classList.remove("spin");
            window.location.href = "/cart";
            return;
        }

        // Step 3: Predict the number of complete bundles after adding missing items
        const newBundleCount = calculateBundleCountPostItemAdd(cartItems, itemsToAdd, all_other_variants);
        console.log("Updated bundle count after adding:", newBundleCount);

        // Step 4: Get current number of gifts in cart
        const currentGiftCount = calculateGiftCount(cartItems, giftData);
        console.log("Current gift count in cart:", currentGiftCount);

        // Step 5: Determine if we need to add more gifts
        let giftsToAdd = [];
        if (newBundleCount > currentGiftCount) {
            const giftQuantityToAdd = newBundleCount - currentGiftCount;
            giftsToAdd.push({ id: giftData[0], quantity: giftQuantityToAdd });
            console.log(`Adding ${giftQuantityToAdd} gift(s) to cart.`);
        }

        // Step 6: Combine missing bundle items and gifts
        const finalItemsToAdd = [...itemsToAdd, ...giftsToAdd];

  return finalItemsToAdd;
}

function getButtonType(button) {
    if (!button) return null;

    if (button.hasAttribute('data-bundle')) {
        return 'bundle';
    } else if (button.hasAttribute('data-add-single')) {
        return 'single';
    }

    return null; // Return null if neither attribute is found
}


                                                  

if (!customElements.get('product-form-wwai')) {
  customElements.define(
    'product-form-wwai',
    class ProductFormWWAI extends HTMLElement {
      constructor() {
        super();
        
        this.form = this.querySelector('form');
        this.giftData=["41439990513751"];
        
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
        
        this.hideErrors = this.dataset.hideErrors === 'true';

        this.all_other_variants = Array.from(document.querySelectorAll('[data-add-single]')).map(btn => btn.dataset.id);
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        this.submitButton.classList.add('spin');
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        console.log("Reached here.");
        const variantId = this.submitButton.dataset.id;
        const buttonType = getButtonType(this.submitButton);

        let items_to_add = []
        if (buttonType === 'bundle') {
            console.log("This is a bundle button");
            // Perform bundle-specific logic
          items_to_add = await getItemsToAddOnBundleAddToCart(variantId, this.all_other_variants, this.giftData);
          
        } else if (buttonType === 'single') {
            console.log("This is a single add-to-cart button");
          items_to_add = await getItemsToAddOnSingleAddToCart(variantId, this.all_other_variants, this.giftData);
            // Perform single product logic
        } else {
            console.log("Unknown button type");
            return;
        }
        console.log("Add items to cart:", items_to_add);

                
        const formData = createCartFormData(items_to_add);
        
        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {

            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id'), cartData: response });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('spin');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            // this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}


                                                  
                                                                            
                                                 
                                                 
});
/* End Section myk_jquery_tqjmRD */

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
